import {
  RESET_DATA_REQUEST,
  RESET_DATA_SUCCESS,
  RESET_DATA_FAILURE,
  RESET_STATUS_REQUEST,
  RESET_STATUS_SUCCESS,
  RESET_STATUS_FAILURE,
} from './types';

const initialState = {
  loading: false,
  error: null,
  data: {
    children: [],
  },
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case RESET_DATA_REQUEST:
      return { ...state, loading: true };
    case RESET_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    case RESET_DATA_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case RESET_STATUS_REQUEST:
      return { ...state, loading: true };
    case RESET_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    case RESET_STATUS_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
}
